var elem = document.getElementById("slider__detail__naturaroo__story");
if (elem !== null) {
	const target = '#slider__detail__naturaroo__story';
	const options = {
      type: 'fade',
      parPage: 1,
	}
	const productNaturarooStorySplide = new Splide(target, options);

	productNaturarooStorySplide.mount();
}
